import PropTypes from 'prop-types'
import { sliceStatusPropTypes } from '../slice.types'

/**
 * @typedef {Object} IntegrationsData
 * @property {boolean} shipper_hq_enabled - Whether ShipperHQ is enabled for this client
 */

/**
 * @typedef {Object} IntegrationsState
 * @property {IntegrationsData|null} data - Integration data from API
 * @property {string|null} mode - The mode used for the last fetch
 */

/** @typedef {import('../slice.types').BaseSlice & IntegrationsState} IntegrationsSlice */

/** @type {IntegrationsSlice} */
export const initialIntegrationsState = {
  status: 'init',
  errors: [],
  data: null,
  mode: null
}

/** @enum {string} */
export const INTEGRATIONS_ACTIONS = {
  SET_INTEGRATIONS_STATUS: 'SET_INTEGRATIONS_STATUS',
  SET_INTEGRATIONS_ERRORS: 'SET_INTEGRATIONS_ERRORS',
  SET_INTEGRATIONS_DATA: 'SET_INTEGRATIONS_DATA',
  SET_INTEGRATIONS_MODE: 'SET_INTEGRATIONS_MODE',

  CLEAR_INTEGRATIONS_ERRORS: 'CLEAR_INTEGRATIONS_ERRORS',
  CLEAR_INTEGRATIONS_DATA: 'CLEAR_INTEGRATIONS_DATA'
}

export const integrationsDataPropType = PropTypes.shape({
  shipper_hq_enabled: PropTypes.bool
})

export const integrationsSlicePropType = PropTypes.shape({
  status: sliceStatusPropTypes,
  errors: PropTypes.arrayOf(PropTypes.shape({ message: PropTypes.string })),
  data: integrationsDataPropType,
  mode: PropTypes.string
})

/**
 * @typedef {{ type: INTEGRATIONS_ACTIONS, payload: IntegrationsSlice['status'] }} IntegrationsStatusAction
 * @typedef {{ type: INTEGRATIONS_ACTIONS, payload: IntegrationsSlice['errors'] }} IntegrationsErrorsAction
 * @typedef {{ type: INTEGRATIONS_ACTIONS, payload: IntegrationsSlice['data'] }} IntegrationsDataAction
 * @typedef {{ type: INTEGRATIONS_ACTIONS, payload: IntegrationsSlice['mode'] }} IntegrationsModeAction
 * @typedef {{ type: INTEGRATIONS_ACTIONS }} IntegrationsClearAction
 *
 * @typedef {IntegrationsStatusAction | IntegrationsErrorsAction | IntegrationsDataAction | IntegrationsModeAction | IntegrationsClearAction} IntegrationsAction
 */
